import { render } from "./DoctorRightSidebar.vue?vue&type=template&id=fe69548c&scoped=true"
import script from "./DoctorRightSidebar.vue?vue&type=script&lang=js"
export * from "./DoctorRightSidebar.vue?vue&type=script&lang=js"

import "./DoctorRightSidebar.vue?vue&type=style&index=0&id=fe69548c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe69548c"]])

export default __exports__